import { INameValuePair, ISettings } from '../types';

const reduceSettings = (settings: INameValuePair[]) =>
  settings.reduce(
    (acc: Record<string, string | boolean | number | string[]>, { name, value }) => ({
      ...acc,
      [name]: name === 'countries' ? value?.split(',') ?? [] : value,
    }),
    {} as Record<keyof ISettings, string | string[]>
  );

export { reduceSettings };
